import './footer.scss';

import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import AndroidBadge from '@images/android_badge.png';
import AppleBadge from '@images/apple_badge.png';

export default function Footer() {
  const [linksVisible, setLinksVisible] = useState(false);
  const [siteInformationVisible, setSiteInformationVisible] = useState(false);

  return (
    <footer aria-label='Footer' className='footer'>
      <div className='footer__container'>
        <div className='footer__links'>
          {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
          <h3 className='navigation-heading' onClick={() => setLinksVisible(!linksVisible)}>
            <i className='icon--down' />
            Links
          </h3>
          <ul className={linksVisible ? 'active' : ''}>
            <li>
              <Link to='/toolkits'>Toolkits</Link>
            </li>
            <li>
              <Link to='/'>Training Materials</Link>
            </li>
          </ul>
        </div>
        <div className='footer__online--training'>
          <Link to='/documents/213'>
            <h3 className='navigation-heading'>Online training</h3>
          </Link>
        </div>
        <div className='footer__site-information'>
          {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
          <h3 className='navigation-heading' onClick={() => setSiteInformationVisible(!siteInformationVisible)}>
            <i className='icon--down' />
            Site information
          </h3>
          <ul className={siteInformationVisible ? 'active' : ''}>
            <li>
              <Link to='/usage-terms'>Terms and conditions</Link>
            </li>
            <li>
              <a href='https://www.shell.com/privacy/b2b-notice.html'>Privacy policy</a>
            </li>
            <li>
              <a href='https://www.shell.com/cookie-policy.html'>Cookies policy</a>
            </li>
          </ul>
        </div>
        <div className='footer__can-we-help'>
          <h3 className='navigation-heading'>Can we help?</h3>
          <ul>
            <li>
              <Link to='/documents/213'>Online training</Link>
            </li>
            <li>
              <a
                href='https://play.google.com/store/apps/details?id=com.shell.sitibv.gids&hl=pl&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'
                target='_blank'
                rel='noopener noreferrer'
              >
                <img alt='Get it on Google Play' src={AndroidBadge} />
              </a>
            </li>
            <li>
              <a
                href='https://apps.apple.com/pl/app/shell-gids/id1437135580?l=pl'
                target='_blank'
                rel='noopener noreferrer'
              >
                <img src={AppleBadge} alt='Download on the App Store' />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
}
